import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { goToTop } from '_helpers';
import { connect } from 'react-redux';

import BlogDetails from './components/BlogDetails';
import BlogList from './components/BlogList';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';

const Blogs = ({
  windowsWidth,
  blogs,
  setDisplayedContent,
  setRef
}) => {
  const [selectedBlogIndex, setSelectedBlogIndex] = useState();

  const learnMoreButtonClickHandler = (index) => {
    setSelectedBlogIndex(index);
    setDisplayedContent('blog');
    eventTracker(events.HOME_SCREEN_BLOG_ITEM_TAP, { blog_item_id: blogs[index].blog_id });
    goToTop();
  };

  const goBackHandler = () => {
    setSelectedBlogIndex();
    setDisplayedContent();
    goToTop();
    setRef('blogsRef');
  };

  const nextBlogHandler = () => {
    setSelectedBlogIndex((prevState) => prevState - 1);
    goToTop();
  };

  const previousBlogHandler = () => {
    setSelectedBlogIndex((prevState) => prevState + 1);
    goToTop();
  };

  return (
    <Container windowsWidth={windowsWidth}>
      <Title>
        {(selectedBlogIndex === 0 || selectedBlogIndex) && (
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
        )}
        {(selectedBlogIndex === 0 || selectedBlogIndex)
          ? blogs[selectedBlogIndex].title : _('education.articles_and_interests')}
      </Title>

      {(selectedBlogIndex === 0 || selectedBlogIndex) ? (
        <BlogDetails
          key={selectedBlogIndex}
          blogs={blogs}
          selectedBlogIndex={selectedBlogIndex}
          nextBlogHandler={nextBlogHandler}
          previousBlogHandler={previousBlogHandler}
          windowsWidth={windowsWidth}
        />
      ) : (
        <BlogList
          blogs={blogs}
          learnMoreButtonClickHandler={learnMoreButtonClickHandler}
          windowsWidth={windowsWidth}
        />
      )}
    </Container>
  );
};

export default connect(
  (store) => ({
    blogs: store.education.blogs,
    selectedLang: store.config.selectedLang
  })
)(Blogs);

const Container = styled.div`
  box-sizing: border-box;
  padding: 10px 0;
  padding-top: 5px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;
  overflow: hidden;
`;

const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;

const Arrow = styled.button`
  display: flex; 
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 0 5px;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  line-height: normal;
  background-color: ${({ background }) => background};

  &:hover {
    border-radius: 50%;
    background-color: #EBEBF0;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
     opacity: 0.3 !important;
     cursor: not-allowed;
     box-shadow: none;
  }
`;
